import { emptySelection, emptySelectionPointBox } from "../../constants";
import { MarketTemplate } from "../../data";
export const fillEmptyMarketSelections = (template) => {
    const selections = [];
    template === MarketTemplate.PointBox && selections.push(Object.assign({}, emptySelectionPointBox));
    const counter = template === MarketTemplate.ThreeBox ? 3 : 2;
    for (let i = 0; i < counter; i++) {
        selections.push(emptySelection);
    }
    return selections;
};
//# sourceMappingURL=fillEmptyMarketSelections.js.map